import dayjs from 'dayjs'
import { mondayOf } from './calendar-layout'

// Current-week helpers shared by the dashboard data hooks (which default their
// fetch window to this week) and the mobile calendar strip.
//
// Week geometry beyond this — arbitrary weeks, months, event placement — lives in
// `calendar-layout`, which is where the navigable calendar reads it from.

export interface WeekDay {
  /** ISO date 'YYYY-MM-DD'. */
  iso: string
  /** Uppercase weekday label, Mon-first. */
  label: string
  dayOfMonth: number
  /** 0 = Mon ... 6 = Sun. */
  dayIndex: number
}

const WEEKDAY_LABELS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']

/** Seven days Mon..Sun for the week containing `ref`. */
export const getWeekDays = (ref: dayjs.Dayjs = dayjs()): WeekDay[] => {
  const monday = mondayOf(ref)
  return WEEKDAY_LABELS.map((label, i) => {
    const d = monday.add(i, 'day')
    return { iso: d.format('YYYY-MM-DD'), label, dayOfMonth: d.date(), dayIndex: i }
  })
}

export const todayIso = (): string => dayjs().format('YYYY-MM-DD')
